import {Box} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

import type {MemexStatus} from '../../api/memex/contracts'
import {StatusUpdateItemBody} from './item/body'
import {StatusUpdateItemHeader} from './item/header'

type Props = {
  status: MemexStatus
}

const statusUpdateItemStyle: BetterSystemStyleObject = {
  border: '1px solid',
  borderColor: 'border.muted',
  boxShadow: 'shadow.small',
  borderRadius: 2,
  flexGrow: 1,
  width: '100%',
  minWidth: 0,
  mt: 3,
}

export const StatusUpdateItem = ({status}: Props) => {
  return (
    <Box as="li" role="listitem" sx={statusUpdateItemStyle}>
      <StatusUpdateItemHeader status={status} />
      <StatusUpdateItemBody status={status} />
    </Box>
  )
}

try{ StatusUpdateItem.displayName ||= 'StatusUpdateItem' } catch {}